import {Component} from '@angular/core';
import {delay, Observable} from "rxjs";
import {SpinnerService} from "./_services/spinner.service";
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import {environment} from "../environments/environment";

@Component({
  selector: 'ehr-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  spinner$: Observable<boolean>;

  constructor(private spinnerService: SpinnerService,
              private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer
  ) {
    console.log("Versie: " + environment.appVersion);
    this.spinner$ = this.spinnerService.spinner$.pipe(delay(0));

    this.matIconRegistry.addSvgIcon(
      "ehr-text",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/text.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-task",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/task.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-action",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/action.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-green-arrow",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/_icons/green-arrow.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-red-arrow",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/_icons/red-arrow.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-assessment",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/assessment.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-ranking",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/ranking.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-rating",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/rating.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-multiple",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/multiple.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-single",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/single.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-short",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/short.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-fact-check",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/fact-check.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-uploading",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/uploading.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-vimeo",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/vimeo.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-upload",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/upload.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-linkedin",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/linkedin.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-indeed",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/indeed.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-monster",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/monster.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-required",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/required.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-not-required",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/not-required.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-reference",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/reference.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-video",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/video.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-survey",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/survey.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-quiz",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/quiz.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-camera",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/camera.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-work-exit",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/work-exit.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-checked",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/checked.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-check",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/check.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-canceled",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/canceled.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-empty-box",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/empty-box.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-x",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/x.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-warning",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/warning.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-breadcrumb",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/breadcrumb.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-logout",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/logout.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-logout-light",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/logout-light.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-logout-dark",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/logout-dark.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-close",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/close.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-search",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/search.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-settings",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/settings.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-settings-light",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/settings-light.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-mode",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/mode.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-mode-light",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/mode-light.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-menus",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/menus.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-dashboard-black",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/dashboard-black.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-dashboard-white",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/dashboard-white.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-dashboard-light",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/dashboard-light.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-dashboard-dark",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/dashboard-dark.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-category-black",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/category-black.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-category-white",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/category-white.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-category-dark",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/category-dark.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-category-light",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/category-light.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-green-arrow-down",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/green-arrow-down.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-red-arrow-up",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/red-arrow-up.svg")
    );


    this.matIconRegistry.addSvgIcon(
      "ehr-arrow-up",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/arrow-up.svg")
    );


    this.matIconRegistry.addSvgIcon(
      "ehr-arrow-down",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/arrow-down.svg")
    );


    this.matIconRegistry.addSvgIcon(
      "ehr-red-exclamation",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/red-exclamation.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-yellow-exclamation",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/yellow-exclamation.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-chart",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/chart.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-filter",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/filter.svg")
    );


    this.matIconRegistry.addSvgIcon(
      "ehr-sick-leave",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/sick-leave.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-health-continuity",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/health-continuity.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-health-service",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/health-service.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-health-service-visit",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/health-service-diagnosis.svg")
    );

    this.matIconRegistry.addSvgIcon(
      "ehr-reintegration-plan",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/reintegration-plan.svg")
    )

    this.matIconRegistry.addSvgIcon(
      "ehr-labor-health-agcy",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/labor-health-agcy.svg")
    )

    this.matIconRegistry.addSvgIcon(
      "ehr-reintegration-evaluation",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/reintegration-evaluation.svg")
    )

    this.matIconRegistry.addSvgIcon(
    "ehr-reintegration-summary",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/reintegration-summary.svg")
    )
  }
}
